import linkifyStr from 'linkify-string';

/**
 * Converts text containing URLs, domains, emails, and other linkable content into HTML with clickable links
 * @param text - The input text that may contain links
 * @returns HTML string with clickable links
 */
export function parseLinksInText(text: string): string {
  if (!text) return text;

  return linkifyStr(text, {
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'text-[color:inherit] underline hover:opacity-80 break-all',
    defaultProtocol: 'https',
  });
}
